<template>
  <div>
    <!-- Search -->
    <button @click="getWorkflowDefinitions">Refresh</button>
    <DataTable
      :rowKeys="['name', 'version']"
      :rows="workflowDefinitions"
      :actions="
        readOnly
          ? [
              {
                name: 'workflowDefinition',
                label: 'View',
                params: {
                  name: 'workflowDefinitionName',
                  version: 'workflowDefinitionVersion'
                }
              }
            ]
          : [
              {
                name: 'workflowDefinition',
                label: 'View',
                params: {
                  name: 'workflowDefinitionName',
                  version: 'workflowDefinitionVersion'
                }
              },
              {
                name: 'workflowDefinitionEdit',
                label: 'Edit',
                params: {
                  name: 'workflowDefinitionName',
                  version: 'workflowDefinitionVersion'
                }
              }
            ]
      "
      :columns="[
        { name: 'name', type: 'text' },
        { name: 'version', type: 'text' },
        { name: 'createTime', type: 'date' },
        { name: 'updateTime', type: 'date' }
      ]"
    />
    <!-- Pagination -->
  </div>
</template>

<script>
// @ is an alias to /src
import { mapActions, mapGetters, mapState } from 'vuex'
import DataTable from '@/components/DataTable.vue'

export default {
  name: 'WorkflowDefinitionList',
  computed: {
    ...mapGetters({
      workflowDefinitions: 'workflowDefinitionsOrderByUpdateTimeDesc'
    }),
    ...mapState(['readOnly'])
  },
  methods: mapActions(['getWorkflowDefinitions']),
  created() {
    this.getWorkflowDefinitions()
  },
  components: {
    DataTable
  }
}
</script>
